<template>
  <div>
    <header class="credit-app-header">
      <div class="logo">
        <a class="icon-saxx-logo"></a>
      </div>
    </header>

    <main v-if="!isSubmitted" class="credit-app-main">
      <section class="card card--form">
        <header class="card__header">
          <h2>{{ language.title_new_account }}</h2>
        </header>

        <AccountForm :lang="lang" :formName="formName" @submit="submit" />
      </section>
    </main>
    <main v-else class="credit-app-main thank-you">
      <section class="card__header">
        <h2>{{ language.text_new_account_confirmation }}</h2>
      </section>
    </main>
  </div>
</template>

<script>
  import { ErrorlessRepository as axios } from "../../repositories/Repository";
  import { mapActions, mapGetters } from "vuex";
  import { language } from '../../lang';
  import { notify } from '../../utils'

  import AccountForm from './AccountForm';

  export default {
    name: "CreateAccount",
    components: {
      AccountForm,
    },
    props: {
      lang: {
        required: false,
        type: String,
        default: 'en',
      },
    },
    data() {
      return {
        formName: "b2b.new-accounts",
      };
    },
    methods: {
      ...mapActions("forms", [
        "setStatus",
        "setErrors",
      ]),
      async submit(fields) {
        this.setStatus({
          form: this.formName,
          status: "loading"
        });

        try {
          await axios.post(
            "/credit-dashboard/accounts",
            this.toFormData(fields), {
              headers: { "content-type": "multipart/form-data" }
            }
          );

          this.setStatus({
            form: this.formName,
            status: "submitted"
          });
        } catch (err) {
          this.setStatus({
            form: this.formName,
            status: "idle"
          });

          if (!err.response) {
            return;
          }
          if(err.response.data.message) {
            notify(err.response.data.message, 'error');
            return;
          }
          if (!err.response.data || !err.response.data.errors) {
            return;
          }
          this.setErrors({
            form: this.formName,
            errors: err.response.data.errors
          });
        }
      },
      toFormData(fields) {
        const form = new FormData;
        Object.keys(fields).forEach(key => {
          const val = fields[key];
          if (Array.isArray(val)) {
            val.forEach((v, index) => form.append(`${key}[${index}]`, v));
            return;
          }

          form.append(key, val);
        });

        return form;
      }
    },
    computed: {
      ...mapGetters("forms", ["getStatus"]),
      language() {
        const lang = language(this.lang);

        return lang.creditDashboard;
      },
      isSubmitted() {
        return this.getStatus({ form: this.formName }) === "submitted";
      },
    },
  };
</script>
